import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { internationals, local } from "../../../data/advisors";

const Advisors = () => {
 
  return (
    <div className='pt-32 pb-20 xs:pt-36 xs:pb-24 sm:pt-40 sm:pb-28 md:pt-44 md:pb-32 lg:pt-48 lg:pb-36 w-full flex flex-col items-center bg-white'>
     
        <div className="flex flex-col justify-center items-center w-full px-4 xs:px-6 sm:px-8 md:w-[90%] xl:w-[90%] space-y-6 xs:space-y-8 sm:space-y-10">
            <p className="text-xl xs:text-2xl sm:text-3xl md:text-4xl font-bold text-[#0863AA] tracking-tight text-center">
              Academic Advisors
            </p>
            <p className="text-sm xs:text-base sm:text-base md:text-lg text-justify leading-relaxed text-gray-700">
              The Benadir University Distinguished Advisory Board is an advisory body, comprised of University alumni and friends, dedicated to supporting and advancing the mission of and highest standards of excellence in the University. University Advisors act as informed advisors to the Trustees and administration on issues of strategic importance through active membership, as requested by the University, in advisory, virtually visiting, and review boards for major programs of the University. Advisors serve as a University resource by volunteering leadership, expertise, and national & international academic support to the areas of the University in which they serve. Advisors also act as ambassadors and promote the interests of the University worldwide.
            </p>
        </div>
    
    <div className="text-black my-6 xs:my-8 sm:my-10 w-full px-3 xs:px-4 sm:px-6 md:px-10 xl:px-20 max-w-[1400px]">
      <Tabs className="w-full">
        <TabList className="flex flex-row justify-center font-bold w-full border-b-2 border-gray-300 mb-6 xs:mb-8">
          <Tab 
            selectedClassName="bg-[#0863AA] text-white" 
            className="px-3 xs:px-4 sm:px-6 md:px-8 lg:px-10 py-2 xs:py-2.5 sm:py-3 text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl text-[#0863AA] hover:cursor-pointer hover:bg-gray-100 transition-all duration-300"
          >
            Local Advisors
          </Tab>
          <Tab 
            selectedClassName="bg-[#0863AA] text-white" 
            className="px-3 xs:px-4 sm:px-6 md:px-8 lg:px-10 py-2 xs:py-2.5 sm:py-3 text-xs xs:text-sm sm:text-base md:text-lg lg:text-xl text-[#0863AA] hover:cursor-pointer hover:bg-gray-100 transition-all duration-300"
          >
            International Advisors
          </Tab>
        </TabList>
        
        <TabPanel>
          <div className="space-y-6 xs:space-y-8 sm:space-y-10 md:space-y-12 my-6 xs:my-8 sm:my-10">
            {local.map((advisor) => (
              <AdvisorCard key={advisor.id} advisor={advisor} />
            ))}
          </div>
        </TabPanel>
        
        <TabPanel>
          <div className="space-y-6 xs:space-y-8 sm:space-y-10 md:space-y-12 my-6 xs:my-8 sm:my-10">
            {internationals.map((advisor) => (
              <AdvisorCard key={advisor.id} advisor={advisor} />
            ))}
          </div>
        </TabPanel>
      </Tabs>
    </div>
  </div>
  );
};

const AdvisorCard = ({ advisor }) => {
  const [showBio, setShowBio] = useState(true);

  // Texts to exclude from subtitle
  const excludedTexts = [
    "School of Public Health and Community Medicine",
    "M.B., B.S., D.C.P. (London), Ph.D. (Histopath. London)",
    "FCPS (Histopath. Pakistan), FRCPath (UK)",
    "The Aga Khan University, Karachi, Pakistan",
    "FRCPath (Histo, UK)",
    "Expert in human morphology, surgical anatomy, and microscopic techniques",
    "BSc and PhD from University of Stockholm, MSc from Umeå University, Sweden",
    "Over 40 years of experience in teaching and research across Somalia, Sudan, Italy, and Saudi Arabia",
    "General Histopathology, Bone and Soft Tissue, Head & Neck"
  ];

  // Check if text should be excluded from subtitle
  const shouldExclude = (text) => {
    if (!text) return true;
    const cleanText = text.trim();
    if (!cleanText) return true;
    
    // Check if the text exactly matches or contains any of the excluded phrases
    return excludedTexts.some(excluded => 
      cleanText === excluded || 
      cleanText.includes(excluded) || 
      excluded.includes(cleanText)
    );
  };

  // Get subtitle text (first occ that's not excluded)
  const getSubtitle = () => {
    if (advisor.occ[0]) {
      const titleOk = !shouldExclude(advisor.occ[0].title);
      const placeOk = !shouldExclude(advisor.occ[0].place);
      
      const title = titleOk ? advisor.occ[0].title : '';
      const place = placeOk ? advisor.occ[0].place : '';
      
      if (title && place) {
        return `${title}, ${place}`;
      } else if (title) {
        return title;
      } else if (place) {
        return place;
      }
    }
    return '';
  };

  const subtitle = getSubtitle();

  return (
    <div className="flex flex-col md:flex-row gap-3 xs:gap-4 sm:gap-5 md:gap-6 lg:gap-8">
      {/* Left Column - Profile Picture */}
      <div className="flex-shrink-0 w-full md:w-[220px] lg:w-[260px] xl:w-[300px]">
        <img 
          src={advisor.avatar} 
          alt={advisor.name} 
          className="w-full h-auto object-cover rounded"
        />
      </div>
      
      {/* Right Column - Content - All content beside the image */}
      <div className="flex-1 min-w-0">
        {/* Name */}
        <h2 className="text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-2 leading-tight">
          {advisor.name}
        </h2>
        
        {/* Subtitle - Role/Affiliation (filtered) */}
        {subtitle && (
          <p className="text-xs xs:text-sm sm:text-base md:text-lg text-gray-700 mb-3 leading-snug">
            {subtitle}
          </p>
        )}

        {/* Bio Panel - Bootstrap-style */}
        <div className="border border-gray-300 rounded shadow-sm">
          {/* Panel Header */}
          <button
            onClick={() => setShowBio(!showBio)}
            className="w-full flex items-center justify-between px-3 xs:px-4 sm:px-5 md:px-6 py-2 xs:py-2.5 sm:py-3 md:py-3.5 bg-gray-50 hover:bg-gray-100 transition-colors focus:outline-none rounded-t"
            aria-expanded={showBio}
          >
            <h3 className="text-xs xs:text-sm sm:text-base md:text-lg font-bold text-gray-900 uppercase tracking-wide">
              Bio
            </h3>
            <svg
              className={`w-4 h-4 xs:w-5 xs:h-5 sm:w-6 sm:h-6 text-gray-600 transition-transform duration-300 ${showBio ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          
          {/* Panel Body */}
          {showBio && (
            <div className="px-3 xs:px-4 sm:px-5 md:px-6 py-3 xs:py-3.5 sm:py-4 md:py-5 bg-white text-gray-800 text-xs xs:text-sm sm:text-base md:text-lg leading-relaxed">
              {advisor.bio
                ? advisor.bio.split("\n\n").map((paragraph, index) => (
                    <p key={index} className="mb-2 last:mb-0 whitespace-pre-wrap">
                      {paragraph}
                    </p>
                  ))
                : advisor.occ.map((position) => (
                    <p key={position.id} className="mb-2 last:mb-0">
                      {position.title}
                      {position.place && ` ${position.place}`}
                      {position.title && position.place && '.'}
                    </p>
                  ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Advisors;
